import { Box, Button, Fade, Modal, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Backdrop from "@mui/material/Backdrop";
import { useContext, useState } from "react";
import CloseMenu from "../../../assets/svg/closeMenu.svg?react";
import ModalCard from "../components/ModalCard";
import Suitcase from "../../../assets/svg/1-suitcase.svg?react";
import Plane from "../../../assets/svg/2-plane.svg?react";
import TravelLuggage from "../../../assets/svg/3-travel-luggage.svg?react";
import Sunrise from "../../../assets/svg/4-sunrise.svg?react";
import Household from "../../../assets/svg/5-household.svg?react";
import Password from "../../../assets/svg/6-password.svg?react";
import Reviews from "../../../assets/svg/7-reviews.svg?react";
import { useAutomation } from "@services";
import { LoadingWrapper } from "@components";
const photo = "/images/automation_step1_photo.png";
import { ToastMessageContext } from "@context/toast-message-cotnext";

const AutomationStep1 = ({ state }: any) => {
  const { showError, showSuccess } = useContext(ToastMessageContext);

  const {
    t,
    i18n: { language },
  } = useTranslation();
  const isRtl = language === "ar";

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1058,
    height: 699,
    backgroundColor: "#FFFFFF",
    boxShadow: 24,
    p: 4,
  };
  /*----------------------
  Mutations & Queries 
-----------------------*/
  const { GeneratePreDefinedAutomationsMutate, GetOnboardingQuery } =
    useAutomation();
  const { refetch } = GetOnboardingQuery();
  const {
    mutate,
    isPending,
    error: mutationError,
  } = GeneratePreDefinedAutomationsMutate({
    onSuccess: () => {
      refetch();

      handleClose();
    },
    onError: (error) => {
      showError(t("ERRORS.SOMETHING_WENT_WRONG"));
    },
  });

  return (
    <>
      <Box
        sx={{
          direction: isRtl ? "rtl" : "ltr",
          height: "55px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          marginBottom: "46px",
        }}
      >
        <Typography
          sx={{
            typography: "h6",

            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "24px",
            letterSpacing: "0%",
            textTransform: "capitalize",
            direction: isRtl ? "rtl" : "ltr",
            color: "#130080",
          }}
        >
          {t("Automation.MessageAutomationManagementHeader")}
        </Typography>
        <Typography
          sx={{
            typography: "body1",

            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "19.2px",
            letterSpacing: "0%",
            direction: isRtl ? "rtl" : "ltr",
            color: "#ADBAC7",
            paddingTop: "10px",
          }}
        >
          {t("Automation.MessageAutomationManagementSubheader")}
        </Typography>
      </Box>

      <Box
        sx={{
          direction: isRtl ? "rtl" : "ltr",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "624px",
          top: "188px",
          left: "24px",
          borderRadius: "12px",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Typography
          sx={{
            width: "fit-content",
            marginTop: "32px",
            typography: "h1",

            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "28.8px",
            direction: isRtl ? "rtl" : "ltr",
            color: "#130080",
          }}
        >
          <span style={{ color: "#5B3FFF", marginInline: "5px" }}>
            {t("Automation.SaveTime")}
          </span>
          {t("Automation.WithAutomatedAdminResponses")}
        </Typography>
        <Typography
          sx={{
            width: "508px",

            fontWeight: 400,
            fontSize: "14px",
            leading: "Cap height",
            lineHeight: "16.8px",
            letterSpacing: "0%",
            textAlign: "center",
            color: "#625783",
            marginTop: "12px",
          }}
        >
          {t("Automation.GetPeaceOfMind")}
        </Typography>
        <Typography
          sx={{
            width: "508px",

            fontWeight: 700,
            fontSize: "18px",
            leading: "Cap height",
            lineHeight: "21.6px",
            letterSpacing: "0%",
            textAlign: "center",
            color: "#625783",
            marginTop: "36px",
          }}
        >
          {t("Automation.GetStartedNow")}
        </Typography>
        <Button
          onClick={handleOpen}
          sx={{
            marginTop: "38px",
            fontSize: "14px",
            width: "200px",
            height: "41px",
            padding: "16px",
            gap: "10px",
            borderRadius: "8px",
            backgroundColor: "#5B3FFF",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#5B3FFF",
            },
          }}
        >
          {t("Automation.StartNow")}
        </Button>

        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Box
                onClick={handleClose}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  cursor: "pointer",
                  fontSize: "24px",
                }}
              >
                <CloseMenu
                  style={{ cursor: "pointer", width: "14px", height: "14px" }}
                />
              </Box>
              <LoadingWrapper loading={isPending} transparent>
                <span
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      width: "fit-content",
                      marginTop: "32px",
                      typography: "h1",

                      fontWeight: 700,
                      fontSize: "24px",
                      lineHeight: "28.8px",
                      direction: isRtl ? "rtl" : "ltr",
                      color: "#130080",
                    }}
                  >
                    <span style={{ color: "#5B3FFF", marginInline: "5px" }}>
                      {t("Automation.SaveTime")}
                    </span>
                    {t("Automation.WithAutomatedAdminResponses")}
                  </Typography>
                  <Typography
                    sx={{
                      width: "508px",

                      fontWeight: 400,
                      fontSize: "14px",
                      leading: "Cap height",
                      lineHeight: "16.8px",
                      letterSpacing: "0%",
                      textAlign: "center",
                      color: "#625783",
                      marginTop: "12px",
                    }}
                  >
                    {t("Automation.GetPeaceOfMind")}
                  </Typography>
                </span>
                <span
                  style={{
                    display: "flex",
                    gap: "16px",
                    marginTop: "32px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ModalCard
                    width="223px"
                    image={<Suitcase />}
                    title={t("Automation.ConfirmationOfBooking")}
                    subtitle={t("Automation.SendThankYouMessage")}
                  />{" "}
                  <ModalCard
                    width="223px"
                    image={<Plane />}
                    title={t("Automation.BeforeCheckIn")}
                    subtitle={t("Automation.SendWelcomeMessage")}
                  />{" "}
                  <ModalCard
                    width="223px"
                    image={<TravelLuggage />}
                    title={t("Automation.ReminderToCheckOut")}
                    subtitle={t("Automation.SendReminder")}
                  />{" "}
                  <ModalCard
                    width="223px"
                    image={<Sunrise />}
                    title={t("Automation.FirstMorning")}
                    subtitle={t("Automation.SendConfirmation")}
                  />
                </span>
                <span
                  style={{
                    display: "flex",
                    gap: "16px",
                    marginTop: "16px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ModalCard
                    width="302px"
                    image={<Household />}
                    title={t("Automation.CleaningRequest")}
                    subtitle={t("Automation.SendRequestToCleaningStaff")}
                  />{" "}
                  <ModalCard
                    width="302px"
                    image={<Password />}
                    title={t("Automation.AutomaticGenerationOfDoorCode")}
                    subtitle={t("Automation.DisplayDoorCode")}
                  />{" "}
                  <ModalCard
                    width="302px"
                    image={<Reviews />}
                    title={t("Automation.EvaluationRequest")}
                    subtitle={t("Automation.SendReminderToGuest")}
                  />{" "}
                </span>
                <span style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    onClick={() => {
                      mutate({ automationType: "predefined" });
                      // state();
                    }}
                    sx={{
                      marginTop: "38px",
                      fontSize: "14px",
                      width: "228px",
                      height: "41px",
                      padding: "16px",
                      gap: "10px",
                      borderRadius: "8px",
                      backgroundColor: "#5B3FFF",
                      color: "#FFFFFF",
                      "&:hover": {
                        backgroundColor: "#5B3FFF",
                      },
                    }}
                  >
                    {t("Automation.Next")}
                  </Button>
                </span>
              </LoadingWrapper>
            </Box>
          </Fade>
        </Modal>

        <img
          style={{ marginTop: "40px", marginBottom: "40px", opacity: 0.5 }}
          src={photo}
          alt="photo"
        />
      </Box>
    </>
  );
};

export default AutomationStep1;
